var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.add_test_screen
        ? _c("q-table", {
            staticClass: "q-mt-md",
            attrs: {
              data: _vm.tests,
              columns: _vm.columns_tests,
              pagination: _vm.server_pagination,
              loading: _vm.loading,
              "row-key": "id",
              "no-data-label": _vm.$t("no_data_avaliable"),
              "no-results-label": _vm.$t("no_results_found"),
              "loading-label": _vm.$t("loading_data"),
              "rows-per-page-label": _vm.$t("items_per_page"),
              "rows-per-page-options": [0],
              "binary-state-sort": ""
            },
            on: {
              "update:pagination": function($event) {
                _vm.server_pagination = $event
              },
              request: _vm.request
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "top",
                  fn: function(props) {
                    return [
                      _c("div", { staticClass: "col" }),
                      _c("q-btn", {
                        attrs: {
                          color: "secondary",
                          icon: "far fa-plus",
                          label: _vm.$t("new"),
                          disable: !_vm.managerTrainings
                        },
                        on: {
                          click: function($event) {
                            return _vm.showTest(0)
                          }
                        }
                      })
                    ]
                  }
                },
                {
                  key: "header",
                  fn: function(props) {
                    return _c(
                      "q-tr",
                      { attrs: { props: props } },
                      _vm._l(props.cols, function(col) {
                        return _c(
                          "q-th",
                          { key: col.name, attrs: { props: props } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t(col.label)) +
                                "\n            "
                            )
                          ]
                        )
                      }),
                      1
                    )
                  }
                },
                {
                  key: "body",
                  fn: function(props) {
                    return _c(
                      "q-tr",
                      { attrs: { props: props } },
                      [
                        _c(
                          "q-td",
                          {
                            key: "id",
                            attrs: { "auto-width": "", props: props }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(props.row.id) +
                                "\n            "
                            )
                          ]
                        ),
                        _c("q-td", { key: "title", attrs: { props: props } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(props.row.title) +
                              "\n            "
                          )
                        ]),
                        _c(
                          "q-td",
                          {
                            key: "group_training_test_type",
                            attrs: { props: props }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.getTestType(
                                      props.row.group_training_test_type
                                    )
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        ),
                        _c(
                          "q-td",
                          { key: "qty_questions", attrs: { props: props } },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(props.row.qty_questions) +
                                "\n            "
                            )
                          ]
                        ),
                        _c(
                          "q-td",
                          {
                            key: "qty_total_questions",
                            attrs: { props: props }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(props.row.qty_total_questions) +
                                "\n            "
                            )
                          ]
                        ),
                        _c(
                          "q-td",
                          { key: "qty_user_results", attrs: { props: props } },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(props.row.qty_user_results) +
                                "\n            "
                            )
                          ]
                        ),
                        _c(
                          "q-td",
                          {
                            key: "status",
                            attrs: { "auto-width": "", props: props }
                          },
                          [
                            _c(
                              "q-chip",
                              {
                                staticClass: "full-width",
                                attrs: {
                                  small: "",
                                  icon: _vm.getIconStatus(props.row.status),
                                  color: _vm.getColorStatus(props.row.status)
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(_vm.getStatus(props.row.status))
                                    ) +
                                    "\n                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-td",
                          { key: "avaliable_in", attrs: { props: props } },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(props.row.avaliable_in) +
                                "\n            "
                            )
                          ]
                        ),
                        _c(
                          "q-td",
                          { key: "test_score", attrs: { props: props } },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(props.row.test_score) +
                                "\n            "
                            )
                          ]
                        ),
                        _c(
                          "q-td",
                          { key: "actions", attrs: { props: props } },
                          [
                            _c(
                              "q-btn",
                              {
                                attrs: {
                                  flat: "",
                                  round: "",
                                  color: "primary",
                                  icon: "far fa-pencil-alt",
                                  disable: !_vm.managerTrainings
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showTest(props.row.actions)
                                  }
                                }
                              },
                              [
                                _c("q-tooltip", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$t("view_or_edit_tooltip")) +
                                      "\n                    "
                                  )
                                ])
                              ],
                              1
                            ),
                            _c(
                              "q-btn",
                              {
                                attrs: {
                                  flat: "",
                                  round: "",
                                  color: "negative",
                                  icon: "far fa-trash-alt",
                                  disable: !_vm.managerTrainings
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.confirmRemove(props.row.actions)
                                  }
                                }
                              },
                              [
                                _c("q-tooltip", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$t("delete_tooltip")) +
                                      "\n                    "
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }
                }
              ],
              null,
              false,
              3702038905
            )
          })
        : _vm._e(),
      !_vm.add_test_screen
        ? _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-3" },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "tertiary",
                    label: _vm.$t("back"),
                    icon: "far fa-chevron-left"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ name: "admin_trainings" })
                    }
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _c("new-test", {
        attrs: {
          add_test_screen: _vm.add_test_screen,
          id_training: _vm.id_training,
          id_test: _vm.id_test,
          test_types: _vm.test_types
        },
        on: {
          returnToTests: function($event) {
            return _vm.returnToTests()
          },
          changeIdTest: _vm.changeIdTest
        }
      }),
      _c(
        "q-dialog",
        {
          on: {
            ok: function($event) {
              return _vm.removeTest()
            }
          },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeTest()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove,
            callback: function($$v) {
              _vm.confirm_remove = $$v
            },
            expression: "confirm_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_item")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_item")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }